/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { ProxyChallengeOptions } from './ProxyChallengeOptions';
import {
    ProxyChallengeOptionsFromJSON,
    ProxyChallengeOptionsFromJSONTyped,
    ProxyChallengeOptionsToJSON,
    ProxyChallengeOptionsToJSONTyped,
} from './ProxyChallengeOptions';

/**
 * 
 * @export
 * @interface ProxyChallenge
 */
export interface ProxyChallenge {
    /**
     * 
     * @type {string}
     * @memberof ProxyChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ProxyChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof ProxyChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {ProxyChallengeOptions}
     * @memberof ProxyChallenge
     */
    options?: ProxyChallengeOptions;
}



/**
 * Check if a given object implements the ProxyChallenge interface.
 */
export function instanceOfProxyChallenge(value: object): value is ProxyChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function ProxyChallengeFromJSON(json: any): ProxyChallenge {
    return ProxyChallengeFromJSONTyped(json, false);
}

export function ProxyChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : ProxyChallengeOptionsFromJSON(json['options']),
    };
}

export function ProxyChallengeToJSON(json: any): ProxyChallenge {
    return ProxyChallengeToJSONTyped(json, false);
}

export function ProxyChallengeToJSONTyped(value?: ProxyChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': ProxyChallengeOptionsToJSON(value['options']),
    };
}

